module.exports = __webpack_public_path__ + "img/prop-bush-2-right.1738591f.png";